/**
 * Returns true when value is a non-empty http(s) URL with a hostname.
 * @param {string} value
 * @returns {boolean}
 */
export const isValidHttpUrl = (value) => {
  const trimmed = (value || "").trim();
  if (!trimmed) return false;
  try {
    const u = new URL(trimmed);
    if (u.protocol !== "http:" && u.protocol !== "https:") return false;
    if (!u.hostname || !u.hostname.includes(".")) return false;
    return true;
  } catch {
    return false;
  }
};

/**
 * @param {string} value
 * @returns {string|null} Error message or null if valid
 */
export const getHttpUrlError = (value, { required = true, fieldLabel = "URL" } = {}) => {
  const trimmed = (value || "").trim();
  if (!trimmed) {
    return required ? `${fieldLabel} is required` : null;
  }
  if (!isValidHttpUrl(trimmed)) {
    return `Enter a valid URL starting with http:// or https://`;
  }
  return null;
};
